import { Collapsible } from "./behaviours/Collapsible.js";
import { Dropdown } from "./behaviours/Dropdown.js";
import { ResponsiveBehaviour } from "@iunctim/utility-frontend/Resources/Public/Scripts/utilities/ResponsiveBehaviour.js";

/**
 * Class to implement the dropdown-menu functionality
 * for a single instance; the application is done
 * via the DropdownMenuManager class
 */
export class DropdownMenu extends ResponsiveBehaviour {
    private static readonly BREAKPOINT: number = 1024;

    /**
     * Constructor of the DropdownMenu
     *
     * @param {HTMLElement} menu
     */
    public constructor(menu: HTMLElement) {
        super();

        // Register the collapsible menu
        this.register(0, new Collapsible(menu));

        // Register the dropdown menu
        this.register(
            DropdownMenu.BREAKPOINT,
            new Dropdown(menu, {
                hover: true,
                debounce: {
                    enter: 75,
                    leave: 25,
                },
            }),
        );

        // Watch for viewport changes
        this.watch();
    }
}
